/**
 * Continuous pulse helper used by ADR-0014 frontier `?` cardback and
 * (forthcoming) player-marker pulse.
 *
 * `sinePulse(timeMs, periodMs, low, high)` maps elapsed milliseconds to a
 * value oscillating between `low` and `high` on a sine curve with period
 * `periodMs`. Phase is fully determined by `timeMs`, so any number of callers
 * sharing the same `timeMs` automatically share phase — no per-element
 * scheduling required.
 */
export function sinePulse(timeMs: number, periodMs: number, low: number, high: number): number {
  const mid = (low + high) / 2;
  const amp = (high - low) / 2;
  const phase = (2 * Math.PI * timeMs) / periodMs;
  return mid + amp * Math.sin(phase);
}

/** Frontier `?` cardback pulse period, 2.4s per ADR-0014 §3 continuous animations. */
export const FRONTIER_PULSE_PERIOD_MS = 2400;
/** Low / high alpha bounds applied to the `?` glyph, per ADR-0014 §3. */
export const FRONTIER_PULSE_LOW = 0.85;
export const FRONTIER_PULSE_HIGH = 1.0;

/** Convenience: the frontier pulse alpha for a given absolute time. */
export function frontierPulseAlpha(timeMs: number): number {
  return sinePulse(timeMs, FRONTIER_PULSE_PERIOD_MS, FRONTIER_PULSE_LOW, FRONTIER_PULSE_HIGH);
}
